import { render } from "./AyudaOtorrinolaringologia.vue?vue&type=template&id=d14aac7c&scoped=true"
import script from "./AyudaOtorrinolaringologia.vue?vue&type=script&lang=js"
export * from "./AyudaOtorrinolaringologia.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=d14aac7c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14aac7c"]])

export default __exports__